// Image assets - exported as URL strings for Vite
// Assets are served from /public/img/ directory

export const AvacusLogo = "/img/avacus-logo.svg";
export const AvacusLogoMobile = "/img/avacus-logo-mobile.svg";
export const ImgHero = "/img/img-hero.png";
export const Img1Inch = "/img/1inch.svg";
export const ImgUniswap = "/img/uniswap.svg";
export const ImgWeb3AdsDesktop = "/img/web3-ads.svg";
export const ImgWeb3AdsMobile = "/img/web3-ads-m.svg";
export const ImgConnectLogo = "/img/connect-logo.svg";
export const BgBackgroundTop = "/img/home-background-top.png";
export const LogoSowakaToken = "/img/sowaka-token-logo.png";
export const ImgSowakaToken = "/img/img-sowaka-token.svg";
export const SowakaTokenLogo1 = "/img/sowaka-token-logo-1.svg";
export const ImgFlowerLeft = "/img/img-flower-left.svg";
export const ImgFlowerRight = "/img/img-flower-right.svg";
export const ImgYoutube = "/img/youtube.svg";
export const ImgTwitter = "/img/twitter.svg";
export const ImgAvatarDefault = "/img/img-avatar-default.svg";
export const ImgFrameAvatar = "/img/img-frame-avatar.svg";
export const ImgNotFound = "/img/img-not-found.svg";
export const ImgAvatarNFT = "/img/img-avatar-nft.svg";
export const ImgBrown = "/img/img-brown.svg";
export const ImgSilver = "/img/img-silver.svg";
export const ImgGold = "/img/img-gold.svg";
export const ImgNoAccount = "/img/img-no-account.svg";
export const ImgNoNFT = "/img/img-no-nft.svg";
export const ImgNoUser = "/img/img-no-user.svg";
export const FallbackImage = "/img/fallback-image.png";
export const FallbackUserAvatar = "/img/fallback-user-avatar.svg";
export const ImgPartyChatEmpty = "/img/img-secure-chat-empty.svg";
export const ImgAccountSetting = "/img/img-account-setting.svg";
export const ImgMaintenanceMode = "/img/maintenance-mode.svg";
